<template>
  <div class="card">
    <div class="card-header">
      <h4 style="padding: 10px">Create New Admin User</h4>
    </div>
    <div class="card-body">
      <form class="forms-sample" @submit.prevent="createAdmin">
        <div class="form-group row" v-if="msg != ''">
          <label class="col-sm-4 col-form-label"></label>
          <div class="col-sm-8">
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
              <strong>{{ msg }}</strong>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Full Name</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" placeholder="Enter admin's full name"
              v-model="adminData.fullName" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Email</label>
          <div class="col-sm-8">
            <input type="email" class="form-control" placeholder="Enter admin's email address"
              v-model="adminData.email" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Mobile Number</label>
          <div class="col-sm-8">
            <input type="tel" class="form-control" placeholder="Enter admin's mobile number"
              v-model="adminData.mobileNumber" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Password</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" placeholder="Enter password"
              v-model="adminData.password" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Confirm Password</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" placeholder="Confirm password"
              v-model="adminData.confirmPassword" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Roles</label>
          <div class="col-sm-8">
            <div class="form-check form-check-flat form-check-primary" v-for="role in availableRoles" :key="role">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="adminData.roles" :value="role" />
                {{ role }}
                <i class="input-helper"></i>
              </label>
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-primary mt-0 text-white float-right" id="submitBtn">
          Create Admin
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "CreateAdmin",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      msg: "",
      adminData: {
        fullName: "",
        email: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        roles: ["ADMIN"]
      },
      availableRoles: ["ADMIN", "MERCHANT", "DEVELOPER", "SUPPORT"]
    };
  },
  methods: {
    async createAdmin() {
      if (this.validateFields()) {
        try {
          const payload = {
            fullName: this.adminData.fullName,
            email: this.adminData.email,
            mobileNumber: this.adminData.mobileNumber,
            password: this.adminData.password
          };

          const response = await api.doPost('/api/admin/create', payload);
          
          if (response.status === "00") {
            this.toast.success(response.message);
            // Reset form
            this.adminData = {
              fullName: "",
              email: "",
              mobileNumber: "",
              password: "",
              confirmPassword: "",
              roles: ["ADMIN"]
            };
            // Redirect to user list
            this.$router.push("/admin/list");
          } else {
            this.msg = response.message || "Failed to create admin user";
          }
        } catch (error) {
          console.error("Error creating admin:", error);
          this.msg = "An error occurred while creating the admin user";
        }
      }
    },
    validateFields() {
      if (
        this.adminData.fullName === "" ||
        this.adminData.email === "" ||
        this.adminData.mobileNumber === "" ||
        this.adminData.password === "" ||
        this.adminData.confirmPassword === ""
      ) {
        this.msg = "Please complete all required fields";
        return false;
      }

      if (this.adminData.password !== this.adminData.confirmPassword) {
        this.msg = "Passwords do not match";
        return false;
      }

      if (this.adminData.roles.length === 0) {
        this.msg = "Please select at least one role";
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
#submitBtn {
  margin-top: 20px;
}
</style> 